import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import MCExample from '@common/images/microcentrifuge_topview_example.svg';
import { Image } from '@learningblocks/shared-components/lib/Image';
import {SwitchButton} from '@learningblocks/shared-components/lib/SwitchButton';
import { Heading } from './Heading';
import { InstructionContent } from './InstructionContent';
import { MCStateContext } from '../..';

import './style.scss';

/**
 * TopViewContent: Renders the content to be displayed in top view of
 * centrifuge modal window
 */
export function TopViewContent(props) {
  const {t} = useTranslation();
  const { isLidOpen } = React.useContext(MCStateContext);


  const microcentrifugeAria = !isLidOpen ? t('MicrocentrifugeClosed.string') : t('MicrocentrifugeSlotLayout.string')

  return (
    <div className='mc_topview_wrapper'>
        <Heading className='mc_topview_instruction_header'/>
        <InstructionContent className='mc_topview_instruction_text'/>
        <div className='mc_topview_instruction_controlWrapper'>
          <div className='switch'>
            <SwitchButton
              value={t("Close_Lid.string")}
              checked={!props.isLidOpen}
              name={t("Close_Lid.string")}
              onChange={() => props.toggleLid() }
            />
            <p>{t("Close_Lid.string")}</p>
          </div>
        </div>
        <div className='mc_topview_instruction_hintWrapper'>
          <div className='mc_topview_instruction_hint'>
            {t('Hint_RotosBalancing.string')}
          </div>
          <Image
            className='mc_topview_instruction_image'
            src={MCExample}
            alt={t('BalancedConfigurationImage.string')}
          />
        </div>
    </div>
  );
}

TopViewContent.propTypes = {
  /**
   * callback function to trigger onclick lid- toggles open and close state of lid
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to trigger on drop at top view of centrifuge
   */
  onDrop: PropTypes.func,
  /**
   * data of all slots
   * slot position start from 1 to 12 ; 1 being at' 12 0 clock' position and so on
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id of slot
       */
      id: PropTypes.number,
      /**
       * specifies if rotor is present
       */
      rotor: PropTypes.bool,
      /**
       * specifes if solution is present
       */
      tube: PropTypes.bool,
    })
  ),
};
